module.exports = __webpack_public_path__ + "img/logo_login.8b6441d9.png";